/* unplugin-vue-components disabled */import { render } from "./RetrievalTypePopup.vue?vue&type=template&id=2d4a5906&scoped=true&ts=true"
import script from "./RetrievalTypePopup.vue?vue&type=script&lang=ts"
export * from "./RetrievalTypePopup.vue?vue&type=script&lang=ts"

import "./RetrievalTypePopup.vue?vue&type=style&index=0&id=2d4a5906&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d4a5906"]])

export default __exports__